import { useTranslation } from "react-i18next";

import type { HaNPersonRow } from "@lib/logic";
import { timeLabel } from "@lib/store/src/data/timeslots/dateTimeHelpers";
import { Avatar } from "@molecules";

type PersonCellProps = {
  row: HaNPersonRow;
};

/** A person in the list: their avatar and name, where they sit and when. */
export const PersonCell = ({ row }: PersonCellProps) => {
  const { t } = useTranslation();
  const { owner, reservation } = row;

  const place = [reservation.workspace.areaName, reservation.workspace.deskName].filter(Boolean).join(", ");

  return (
    <div className="flex w-full min-w-0 items-center gap-3">
      <Avatar
        className="flex-none"
        size="large"
        user={{
          id: owner.id,
          email: owner.email,
          initials: owner.initials ?? "",
          name: owner.name,
          imageHash: owner.imageHash,
        }}
      />

      <div className="flex min-w-0 flex-col gap-0.5">
        <p className="truncate font-semibold">{owner.name}</p>
        <p className="truncate text-mapiq-black-500">{place}</p>
      </div>

      <p className="ml-auto flex-none text-sm">{timeLabel(reservation.localStart, reservation.localEnd, t)}</p>
    </div>
  );
};
